import React from 'react';
import {legacyIncome} from "../../../../../components/client/application-stages/_common/lender-tests/useXlsTests";
import dayjs from "dayjs";
import MortgageForm from "../../../../../components/data-capture/MortgageForm";

function ApplicationForm({section, inExtWindow=true}) {

    let target = section.applicant === 1 ? `applicant1` : `applicant2`

    let legacy = legacyIncome(section.mortgage)

    let target2 = legacy ? `${target}.employment` : `${target}.employmentIncome[${section.mortgage[target].employmentIncome[0]?.id}]`
    let questions = [
        {
            name: 'ppsNumber',
            label: 'PPS Number',
            answer: {
                type: 'text',
            },
            target: `${target}.tax.ppsNumber`
        }, {
            name: 'currentEmployerName',
            label: 'Current Employer Name',
            answer: {
                type: 'text',
            },
            target: `${target2}.currentEmployerName`
        }, {
            name: 'currentEmployerStartDate',
            label: 'Start Date',
            answer: {
                type: 'date',
            },
            target: `${target2}.currentEmployerStartDate`
        }, {
            name: 'previousEmployerName',
            label: 'Previous Employer Name',
            answer: {
                type: 'text',
            },
            hides: (form) => {
                let day = form.getFieldValue('currentEmployerStartDate')
                if (day && dayjs.isDayjs(day)) {
                    return dayjs().diff(day, 'years') >= 3
                }
                return true
            },
            target: `${target2}.previousEmployerName`
        }, {
            name: 'previousEmployerStartDate',
            label: 'Prev Start Date',
            answer: {
                type: 'date',
            },
            hides: (form) => {
                let day = form.getFieldValue('currentEmployerStartDate')
                if (day && dayjs.isDayjs(day)) {
                    return dayjs().diff(day, 'years') >= 3
                }
                return true
            },
            target: `${target2}.previousEmployerStartDate`
        }, {
            name: 'previousEmployerEndDate',
            label: 'End Date',
            answer: {
                type: 'date',
            },
            hides: (form) => {
                let day = form.getFieldValue('currentEmployerStartDate')
                if (day && dayjs.isDayjs(day)) {
                    return dayjs().diff(day, 'years') >= 3
                }
                return true
            },
            target: `${target2}.previousEmployerEndDate`
        }
    ]
    return <MortgageForm questions={questions}/>
}

export default ApplicationForm;